import React, { useCallback } from 'react';
import { Box, FormProvider, getValidationResolver, SubmitHandler, useForm } from '@common-fe/common-fe';

import { VALIDATORS } from '@/common';

import { FieldLevelAccessValue, IFieldLevelAccessSetup } from '../../role.types';
import FieldLevelAccessPropertiesConfirmSetup from '../FieldLevelAccessSetupConfirmModal/FieldLevelAccessPropertiesConfirmSetup';

import BasicProperties from './BasicProperties/BasicProperties';
import FieldLevelAccessAppliedToSection from './BasicProperties/FieldLevelAccessAppliedToSection';

interface Props {
  title?: React.ReactNode;
  isModalMode?: boolean;
  isCopyMode?: boolean;
  isViewMode?: boolean;
  isCreateMode?: boolean;
  isLoading?: boolean;
  defaultValues?: IFieldLevelAccessSetup | null;
  footer?: React.ReactNode;
  children?: React.ReactNode;
  onSubmit?: (value: IFieldLevelAccessSetup) => void;
  onSetProperties?: (values: { [key: string]: FieldLevelAccessValue }) => void;
  onSetOverridableProperties?: (values: { [key: string]: FieldLevelAccessValue }) => void;
}

const FieldLevelAccessSetupForm: React.FC<Props> = ({
  title,
  isViewMode,
  footer,
  children,
  isLoading = false,
  defaultValues,
  isModalMode,
  isCopyMode,
  isCreateMode,
  onSubmit,

}) => {
  const methods = useForm<IFieldLevelAccessSetup>({
    defaultValues: defaultValues || undefined,
    resolver: getValidationResolver({
      name: VALIDATORS.REQUIRED_STRING,
    }),
  });

  const handleSubmit: SubmitHandler<IFieldLevelAccessSetup> = useCallback(
    (data) => {
      if (onSubmit) {
        onSubmit(data);
      }
    },
    [onSubmit]
  );

  return (
    <Box direction="column">
      <Box align="center" justify="center">
        {title}
      </Box>
      <FormProvider {...methods}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            e.stopPropagation();
            methods.handleSubmit(handleSubmit)(e);
          }}
        >
          <Box direction="column">
            <Box round="moduleRound" background="module" pad="l">
              <BasicProperties
                defaultValues={{
                  ...defaultValues,
                }}
                isModalMode={isModalMode}
                isLoading={isLoading}
                isEditMode={!isViewMode}
              />

              {(defaultValues?.id && isViewMode) && (
                <FieldLevelAccessAppliedToSection
                  isLoading={isLoading}
                  roles={defaultValues?.roles}
                  isModalMode={isModalMode}
                />
              )}

              {(isViewMode || isCopyMode || isCreateMode) && (
                <Box
                  round="container1Round"
                  background="canvas"
                  margin={{ top: 'l' }}
                  pad="l"
                  border={{ size: 'small', color: 'border1' }}
                >
                  <FieldLevelAccessPropertiesConfirmSetup
                    isLoading={isLoading}
                    properties={defaultValues?.properties}
                    overridableProperties={defaultValues?.overridableProperties}
                    isEditMode={isCreateMode}
          
                  />
                </Box>
              )}

              {children}
            </Box>
          </Box>
          {footer}
        </form>
      </FormProvider>
    </Box>
  );
};

export default FieldLevelAccessSetupForm;
